import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('[AdminCrash]', error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{
          padding: 20, fontFamily: 'monospace', fontSize: 12,
          color: '#fca5a5', background: '#0b0f1c', minHeight: '100vh',
          whiteSpace: 'pre-wrap', wordBreak: 'break-word'
        }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 12, color: '#ef4444' }}>
            Terjadi error saat render
          </div>
          <div style={{ marginBottom: 14 }}>{String(this.state.error)}</div>
          <div style={{ color: '#94a3b8', fontSize: 11 }}>
            {this.state.info?.componentStack?.split('\n').slice(0, 12).join('\n')}
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 18, padding: '10px 18px', border: 'none', borderRadius: 10,
              background: 'linear-gradient(135deg,#a06bff,#22d3ee)', color: '#05070f',
              fontWeight: 700, cursor: 'pointer'
            }}>
            Muat Ulang
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ErrorBoundary><App /></ErrorBoundary>);
